module.exports = __webpack_public_path__ + "img/illustration3.89fc36ec.svg";